<!--@todo: taxtankit TT-5835 move multiple select with <ngx-mat-select-search to separate component -->
<mat-form-field [class]=inputClass>
  <mat-label>{{ label }}</mat-label>
  <mat-select [formControl]="ngControl.control"
              [multiple]="multiple"
              [placeholder]=placeholder>
    <mat-option>
      <ngx-mat-select-search [formControl]="filterCtrl"
                             placeholderLabel="Find currency"
                             noEntriesFoundLabel="No currencies found">
      </ngx-mat-select-search>
    </mat-option>
    @for (currency of filteredOptions; track currency.code) {
      <mat-option [value]="currency.code">{{ currency.name | titlecase }}</mat-option>
    }
  </mat-select>
</mat-form-field>
